module.exports = [
  {
    type: 'h1',
    title: 'X-Large Header',
    icon: 'icon-h1',
    content: 'Header 1'
  },
  {
    type: 'h2',
    icon: 'icon-h2',
    title: 'Large Header',
    content: 'Header 2'
  },
  {
    type: 'h3',
    icon: 'icon-h3',
    title: 'Small Header',
    content: 'Header 3'
  },
  {
    type: 'text',
    icon: 'icon-p',
    title: 'Paragraph',
    content: '<p></p>'
  },
  {
    type: 'bulleted-list',
    icon: 'icon-bulleted-list',
    title: 'Bulleted List',
    content: '<ul><li>First item...</li></ul>'
  },
  {
    type: 'numbered-list',
    icon: 'icon-numbered-list',
    title: 'Numbered List',
    content: '<ol><li>First item...</li></ol>'
  },
  {
    type: 'image',
    icon: 'icon-image',
    title: 'Image',
    content: ''
  },
  {
    type: 'pricing-table',
    icon: 'icon-pricing-table',
    title: 'Pricing Table',
    content: null
  },
  {
    type: 'page-break',
    icon: 'icon-page-break',
    title: 'Page Break',
    content: '<hr class="page-break">'
  },
  {
    type: 'signatures',
    icon: 'icon-signature',
    title: 'Signatures',
    content: null
  }
];



// WEBPACK FOOTER //
// ./resources/assets/js/settings/documentPartsList.js